/**
 * Relay for Log Out
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const LogoutPageQuery = graphql`
  query logout_Query {
    viewer {
      ...logout_viewer
    }
  }
`;

export const LogoutFormFragment = graphql`
  fragment logout_viewer on Viewer {
    id
  }
`;

export const LogoutMutation = graphql`
  mutation logout_Mutation($input: LogoutInput!) {
    logout(input: $input) {
      clientMutationId
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/logout.ts